import { effect as _$effect } from "@opentui/solid";
import { insert as _$insert } from "@opentui/solid";
import { createTextNode as _$createTextNode } from "@opentui/solid";
import { insertNode as _$insertNode } from "@opentui/solid";
import { memo as _$memo } from "@opentui/solid";
import { setProp as _$setProp } from "@opentui/solid";
import { createElement as _$createElement } from "@opentui/solid";
import { useTheme } from "../context/theme";
export function TodoItem(props) {
  const {
    theme
  } = useTheme();
  return (() => {
    var _el$ = _$createElement("box"),
      _el$2 = _$createElement("text"),
      _el$3 = _$createTextNode(`[`),
      _el$4 = _$createTextNode(`] `),
      _el$6 = _$createElement("text");
    _$insertNode(_el$, _el$2);
    _$insertNode(_el$, _el$6);
    _$setProp(_el$, "flexDirection", "row");
    _$setProp(_el$, "gap", 0);
    _$insertNode(_el$2, _el$3);
    _$insertNode(_el$2, _el$4);
    _$setProp(_el$2, "flexShrink", 0);
    _$insert(_el$2, (() => {
      var _c$ = _$memo(() => props.status === "completed");
      return () => _c$() ? "✓" : props.status === "in_progress" ? "•" : " ";
    })(), _el$4);
    _$setProp(_el$6, "flexGrow", 1);
    _$setProp(_el$6, "wrapMode", "word");
    _$insert(_el$6, () => props.content);
    _$effect(_p$ => {
      var _v$ = {
          fg: props.status === "in_progress" ? theme.warning : theme.textMuted
        },
        _v$2 = {
          fg: props.status === "in_progress" ? theme.warning : theme.textMuted
        };
      _v$ !== _p$.e && (_p$.e = _$setProp(_el$2, "style", _v$, _p$.e));
      _v$2 !== _p$.t && (_p$.t = _$setProp(_el$6, "style", _v$2, _p$.t));
      return _p$;
    }, {
      e: undefined,
      t: undefined
    });
    return _el$;
  })();
}